export const LogoVisma = (props) => (
  <svg
    width={91}
    height={18}
    viewBox="0 0 91 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_11275_169465)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.069 0.720459C14.9116 1.18915 20.2229 3.61017 23.2694 7.12535C27.1746 11.5774 25.8472 16.0299 20.301 17.0449C14.7554 18.1385 7.10062 15.3269 3.19541 10.8743C0.227039 7.43726 0.305703 4.00075 3.03918 2.12653L18.4262 13.5302L10.069 0.720459Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.3013 17.0448L84.3489 9.2338C84.1135 8.29697 83.9578 7.35958 83.8021 6.50032H83.7235C83.5678 7.4377 83.4891 8.29696 83.2548 9.31191L81.3013 17.0448H77.9429L82.3955 0.798463H85.0514L89.7383 17.0448H86.3013ZM35.0632 0.798463L37.0161 8.60888C37.3286 9.54626 37.4067 10.4842 37.5629 11.3424H37.641C37.7973 10.4055 37.8754 9.46759 38.1097 8.53076L40.0626 0.798463H43.421L38.969 17.0448H36.3131L31.6267 0.798463H35.0632ZM45.8415 0.798463H49.0442V17.0448H45.8415V0.798463ZM67.1658 0.798463L68.8051 10.4061L70.1331 0.798463H74.4289L76.0693 17.0448H72.789L72.0078 5.32859L71.461 9.31191L70.1331 17.0448H67.6339L66.0716 9.2338L65.5248 5.64105V5.32859H65.4467L64.978 17.0448H61.541L62.9476 0.798463H67.1658ZM57.0114 0.798463C56.4646 1.18904 56.0745 1.89152 55.7621 2.59456C54.9028 4.54744 55.8397 6.10919 56.6208 7.51526C56.6995 7.67149 56.8562 7.90584 56.9333 8.14019C58.7299 11.108 59.3548 13.2947 58.1055 16.4187L57.7931 17.0442H53.8873C54.356 16.6531 54.8242 16.1074 55.0585 15.4819C55.9964 13.3728 54.9028 11.4205 53.8873 9.46704C52.7161 7.20225 51.4658 4.85935 52.7937 1.65663C52.8724 1.34417 53.1848 0.797363 53.1848 0.797363H57.0114V0.798463Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_11275_169465">
        <rect
          width={90}
          height={18}
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
